import { css } from '@emotion/core';
import theme from 'lib/theme';

export default css`
  .gm-style {
    font-family: ${theme.fontFamily} !important;
  }
`;
